import React from 'react';
import { Player } from '@lottiefiles/react-lottie-player';
import lottie_driving_car_success from '../media/lottie_driving_car_success.json';
import Slogan from '../component/Slogan'
import './HomeIntro.css';

export default class HomeIntro extends React.Component {
    render() {
        return (
            <div className="App-home-intro">
                <Slogan className="App-home-intro-slogan" hasAnimation={false} />
                <div className="App-home-intro-animation">
                    <Player autoplay loop src={lottie_driving_car_success} />
                </div>
            </div>
        );
    }
}